import { yupResolver } from '@hookform/resolvers/yup';
import { AxiosError } from 'axios';
import { ChangeEvent, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import StickButtonsBloc from '../../blocs/common/StickButtonsBloc';
import { APP_URLS, ERROR_MESSAGES, MAX_SMALL_MOBILE_WIDTH } from '../../const/AppConst';
import useAppState from '../../context/AppContext';
import { IApiErrors, IExtractedSecurityInfo, IUploadedDocument} from '../../context/model';
import MgpFormCheckbox from '../../elements/MgpFormCheckbox/MgpFormCheckbox';
import MgpFormInput from '../../elements/MgpFormInput/MgpFormInput';
import MgpMessage from '../../elements/MgpMessage/MgpMessage';
import LoaderModal from '../../modals/common/LoaderModal';
import UploadFilePreviewModal from '../../modals/common/UploadFilePreviewModal';
import { deleteDocument, downloadUploadedDocument, uploadSocialSecurity } from "../../services/CustomerApiService";
import { accessJsonAttr, getCompressFile, getFilename, isAcceptedFileSize, isValidFileSize, isValidFileType } from '../../utils/utils';
import QrCodeModal from '../../modals/common/QrCodeModal';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import { displaySecuNumber, isPropositionInLock } from '../../utils/dataUtils';
import ListOfFileUploaded from '../common/ListOfFileUploaded';
import UploadFromPhoneButton from '../common/UploadFromPhoneButton';
import MgpInputFileUpload from '../../elements/MgpInputFileUpload/MgpInputFileUpload';
import ImageModal from '../../modals/common/ImageModal';

type InfoPersoStep3FormData = {
  attachmentOrganization: string;
  fileAttachId: string | null;
  alsaceMoselleRegime: boolean;
}

export default function InfoPersoStep3FormComponent() {

  const {
    state: { proposition, updatedProposition, jwtToken, socialSecurityDocuments, showModal },
    dispatch,
  } = useAppState();
  const validationSchema = Yup.object().shape({
    fileAttachId: Yup.string().required(ERROR_MESSAGES.requiredMsg),
    attachmentOrganization: Yup.string().required(ERROR_MESSAGES.requiredMsg)
                                        .min(11, ERROR_MESSAGES.invalidMsg)
                                        .max(11, ERROR_MESSAGES.invalidMsg)
                                        .matches(/^[0-9, ]+$/i, ERROR_MESSAGES.invalidMsg),
  });
  
  const [errorMsg, setErrorMsg] = useState<string | null>();
  
  const [errorFileTypeMsg, setErrorFileTypeMsg] = useState<boolean | null>();
  const [errorFileSizeMsg, setErrorFileSizeMsg] = useState<boolean | null>();
  const [loading, setLoading] = useState<boolean>(false);
  const [file, setFile] = useState<File | null>(null);
  const [openPreviewFile, setOpenPreviewFile] = useState<boolean>(false);
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [showUploadButton, setShowUploadButton] = useState<boolean>(false);
  const [isPrincipalDoc, setIsPrincipalDoc] = useState<boolean>(false); 
  const [imageUrl, setImageUrl] = useState<string>('');
  const [modalText, setModalText] = useState<string>('');

  const {width} = useWindowDimensions();
  const isDesktop = width > MAX_SMALL_MOBILE_WIDTH;

  const showQrCodePrincipal= () => {
    setIsPrincipalDoc(true)
    setIsShowModal(true);
  }


  const showQrCodeModal = () => {
    setIsShowModal(true);
  }
  const closeModal = () => {
    setIsShowModal(false)
  }

  const handleFileChange = async (event: ChangeEvent<HTMLInputElement>, isPrincipalDoc: boolean) => {
    try {
      const uploadedfile = event.target.files ? event.target.files[0] : null;
  
      if (uploadedfile) {
        if(!isValidFileType(uploadedfile)) {
          setErrorFileTypeMsg(true)
        } else if(!isValidFileSize(uploadedfile)) {
          setErrorFileSizeMsg(true)
        } else if (!isAcceptedFileSize(uploadedfile)) {
          try {
            const token = jwtToken!.accessToken;
            const newFile = await getCompressFile(token, uploadedfile);
            setFile(newFile);
            setOpenPreviewFile(true);
            setShowUploadButton(true);
            setIsPrincipalDoc(isPrincipalDoc);
            dispatch({type: 'SHOW_MODAL', showModal: true});   
          } catch(e) {
            setErrorMsg("Suite à un incident technique, nous ne pouvons pas uploader votre fichier. Veuillez sélectionner à nouveau.");
          }    
        } else {
          setFile(uploadedfile);
          setOpenPreviewFile(true);
          setShowUploadButton(true);
          setIsPrincipalDoc(isPrincipalDoc);
          dispatch({type: 'SHOW_MODAL', showModal: true});
        }
      }
    } catch (error) {
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  };

  const navigate = useNavigate();

  const {
    register,
    handleSubmit, setValue,
    formState: { errors, isSubmitting },
  } = useForm<InfoPersoStep3FormData>({
    mode: "onBlur",
    reValidateMode: "onChange",
    defaultValues: {
      attachmentOrganization: updatedProposition?.attachmentOrganization ? updatedProposition.attachmentOrganization.replace(/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3').trim() : '',
      fileAttachId: socialSecurityDocuments.find(doc => doc.name === "Attestation de droits") ? socialSecurityDocuments.find(doc => doc.name === "Attestation de droits")!.id : null,
      alsaceMoselleRegime: updatedProposition?.alsaceMoselleRegime ? true : false
    },
    resolver: yupResolver(validationSchema),
  });
 
  const onNextAction = (data: InfoPersoStep3FormData) => {
    let tempUpdatedPropo = updatedProposition;
    if(tempUpdatedPropo) {
      tempUpdatedPropo.attachmentOrganization = data.attachmentOrganization.replace(/ /g, '');
      tempUpdatedPropo.alsaceMoselleRegime = data.alsaceMoselleRegime;
    };
    if(socialSecurityDocuments.length < 1) {
      return;
    };
    dispatch({type: 'NEXT_INFO_STEP', path: APP_URLS.infoPersoStep4Page, updatedProposition: tempUpdatedPropo});
    navigate({
      pathname: APP_URLS.infoPersoStep4Page,
      search: `?id=${proposition!.propositionId}`,
    });
  }

  const onUploadAction = async () => {
    setErrorMsg(null);
    setErrorFileTypeMsg(false);
    setErrorFileSizeMsg(false);
    setLoading(true);
    try {
      const token = jwtToken!.accessToken;
      const res = await uploadSocialSecurity(token, proposition!.propositionId, file as File, true, isPrincipalDoc);
      
      setLoading(false);
      if (res.data) {
        const secuDocument = res.data;
        onUpdatedFormValue(secuDocument);
      } else {
        setErrorMsg(ERROR_MESSAGES.lowQualityDoc);
      }
    } catch (error) {
      setLoading(false);
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else {
        setErrorMsg("Une erreur technique est survenue.");
      }
    }
  }

  const onEventMessage = (message: any, type: string) => {
    if(type === 'upload') {
      const socialSecurityDocuments = message as IUploadedDocument<IExtractedSecurityInfo>;
      onUpdatedFormValue(socialSecurityDocuments);
      setIsShowModal(false);
      setShowUploadButton(false);
    }
  }

  const onUpdatedFormValue = (secuDocument: IUploadedDocument<IExtractedSecurityInfo>) => {
    if (isPrincipalDoc) {
          setValue('fileAttachId', secuDocument.id);
          if (secuDocument.extractedData?.beneficiaries?.length > 0) {
            const principalBeneficiary = secuDocument.extractedData.beneficiaries.find(user => user.isPrincipalBeneficiary);
            if(principalBeneficiary && principalBeneficiary.nir === proposition?.contact.nir && principalBeneficiary.nirKey === proposition?.contact.nirKey) {
                setValue("attachmentOrganization", principalBeneficiary.socialSecurityOrg.replace(/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3').trim(), {shouldValidate: true});
            }
          }  
    };
  
    dispatch({type: 'EXTRACT_SECU_ATTEST', socialSecurityDocuments: [...socialSecurityDocuments, secuDocument]});
  }


  const onPreviousAction = () => {
    dispatch({type: 'BACK_INFO_STEP', path: APP_URLS.infoPersoStep2Page});
    navigate({
      pathname: APP_URLS.infoPersoStep2Page,
      search: `?id=${proposition!.propositionId}`,
    });
  }

  const onDownLoadDocument = async (documentId: string) => {
    try {
      const token = jwtToken!.accessToken;
      const res = await downloadUploadedDocument(token, proposition!.propositionId, documentId);
      const content = new Blob([res.data], {type: res.headers['content-type']});
      const filename = getFilename(res.headers);
      const file = new File([content], filename);
      setFile(file);
      setOpenPreviewFile(true);
      setShowUploadButton(false);
      dispatch({type: 'SHOW_MODAL', showModal: true});

    } catch (error) {
      setLoading(false);

      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else if (err.response && err.response.status === 404) {
        setErrorMsg(ERROR_MESSAGES.documentNotFound);
      }else {
        setErrorMsg("Une erreur technique est survenue ");
      }
    }
  }

  const onDeleteDocLocal = (documentId: string, documentName: string) => {
    const newDocumentArray = [...socialSecurityDocuments];
    const index= newDocumentArray.findIndex(el => el.id === documentId);
    newDocumentArray.splice(index, 1);
    dispatch({type: 'EXTRACT_SECU_ATTEST', socialSecurityDocuments: newDocumentArray});
    
    if (documentName === "Attestation de droits") {
      setValue('fileAttachId', null);
    };
  }

  const onDeleteDocument = async (documentId: string, documentName: string) => {
    setLoading(true);
    try {
      const token = jwtToken!.accessToken;
      await deleteDocument(token, proposition!.propositionId, documentId);

      onDeleteDocLocal(documentId, documentName);
      setLoading(false);
      setErrorMsg(null);
      
    } catch (error) {
      const err = error as AxiosError;
      console.log(err);
      if(err.response && err.response.status === 400) {
        const errorData = err.response?.data as IApiErrors;
        setErrorMsg("Erreur: " + errorData.message);
      } else if (err.response && err.response.status === 404) {
        onDeleteDocLocal(documentId, documentName);
        setErrorMsg(null);
      } else {
        setErrorMsg("Une erreur technique est survenue ");
      }
      setLoading(false);
    }
    
  }

  const handleOpenInfoModal = (e: any, image: string, text?: string) => {
    e.preventDefault();
    setImageUrl(image);
    if (text) setModalText(text);
  }

  const handleCloseInfoModal = () => {
    setImageUrl('');
    setModalText('');
  }

  const displayPrincipalBeneficiary = () => {
    let attachmentOrganization = proposition?.contact.attachmentOrganization;
    let message = '';
    let status = 'info';

    const attestationPrincipal = socialSecurityDocuments.find(doc => doc.name === "Attestation de droits");
   
    if(attestationPrincipal && !attestationPrincipal.extractedData?.isValid) {
      message = 'Nous n\'avons pas réussi à identifier le document. Nous vous invitons à nous le transmettre sous un autre format ou à saisir vos données.';
        status = 'alert';
    } else if(attestationPrincipal && attestationPrincipal.extractedData?.isValidDuration === false) {
      message = 'Votre attestation de droits à l’assurance maladie n’est plus valable. Vous devez télécharger une attestation de droits à jour.';
        status = 'alert';
    } 
   
    else if (attestationPrincipal?.extractedData && attestationPrincipal.extractedData.beneficiaries?.length > 0) {
      const principalBeneficiary = attestationPrincipal.extractedData.beneficiaries.find(user => user.isPrincipalBeneficiary);

      if (!principalBeneficiary) {
        message = 'Nous n’avons pas réussi à identifier votre numéro de sécurité sociale sur le document. Nous vous invitons à vous assurer qu’il s’agit bien de votre attestation de droits à l’assurance maladie.';
          status = 'alert';
      } else {
        if (principalBeneficiary.nir !== proposition?.contact.nir || principalBeneficiary.nirKey !== proposition?.contact.nirKey) {
          message = 'Nous n’avons pas réussi à identifier votre numéro de sécurité sociale sur le document. Nous vous invitons à vous assurer qu’il s’agit bien de votre attestation de droits à l’assurance maladie.';
          status = 'alert';
        } else {
          if (attachmentOrganization && attachmentOrganization !== principalBeneficiary.socialSecurityOrg) {
            message = 'Nous n’avons pas réussi à identifier votre organisme de rattachement sur le document. Votre attestation de droits à l’assurance maladie doit être bien lisible et à jour.';
            status = 'alert';
          }

          if (!attachmentOrganization && principalBeneficiary.socialSecurityOrg) {
            attachmentOrganization = principalBeneficiary.socialSecurityOrg;
            message = 'Veuillez vérifier que votre organisme de rattachement est correct. N’hésitez pas à le corriger si besoin.';
            status = 'info';
          }
        }
      }
    }

    return (<div>
      {message &&
        <p className={'text bg-menthe blanc m-y-md p-sm mw-100 ' + (status === 'alert' ? 'bg-orange' : 'bg-menthe')}>
          {message}
        </p>
      }
      <div className='form-row'>
        {attestationPrincipal ?
          <div className="form-row">
            <div className='form-group mw-100'>
              <ListOfFileUploaded 
                fileName={attestationPrincipal.name}
                onDownloadDocument={() => onDownLoadDocument(attestationPrincipal.id)}
                onDeleteDocument={() => onDeleteDocument(attestationPrincipal.id, attestationPrincipal.name)}
              />
            </div>
          </div>
          :
          <div className='form-group'>
            <div className="form-row">
              <div className='form-group mw-45 m-y-md'>
                <MgpInputFileUpload
                id="fileAttachId"
                onChange={(e) => handleFileChange(e, true)}
                register={register} 
                errors={errors}
                required={true}
                onClick={(e)=> e.currentTarget.value = ''}
                />
              </div>
              {
                isDesktop && <div className="form-group mw-5 ta-center" style={{paddingTop: "100px"}}><p className='fz-lg'>ou</p></div>
              }
              {isDesktop && 
              <div className='form-group mw-45'>
                <UploadFromPhoneButton onClick={() => showQrCodePrincipal()}/> 
              </div>}
            </div>
            {errors && accessJsonAttr(errors, 'fileAttachId') && <p className="error mt-sm fushia">(*) Votre attestation est obligatoire pour passer à la prochaine étape</p>} 
          </div>
        }
      </div>
    </div>);
  }

  const displaySocialSecurityInfo = () => {
    return (<div>
      <div className=''>
        <div className='form-row'>
          <div className="form-group mw-100">
                <MgpFormInput
                  label="Numéro de sécurité sociale"
                  id="contact.nir"
                  labelFontWeight='regular'
                  value={displaySecuNumber(proposition?.contact.nir, proposition?.contact.nirKey)}
                  disabled={true}
                />
          </div>
        </div>
       
          <div className="form-row">
            <div className="form-group mw-100">
              <MgpFormInput
                label="Organisme de rattachement"
                id="attachmentOrganization"
                labelFontWeight='regular'
                register={register}
                errors={errors}
                required={true}
                regex={[/(\d{2})(\d{3})(\d{4})/, '$1 $2 $3']}
                handleClickInfo={(e: any) => handleOpenInfoModal(e, 'Image_AM_1.jpg', "L'organisme de rattachement est composé de 9 chiffres.")}
                tooltipText="Cliquez pour voir les instructions"
                maxLength={9}
              />
            </div>
          </div>
      </div>  
     
      <div className="pb-xl pt-sm form-row">
        <div className="form-group form-check mw-100">
          <MgpFormCheckbox id='alsaceMoselleRegime' label="Je relève du régime Alsace-Moselle" register={register} errors={errors} />
        </div> 
      </div>
    </div>)
  }
  
  return (         
      <form style={{width: '100%'}}> 
        <div className='form-row page-content'>
          <div className='col-flex-4 bg-blanc shadow-noir p-md m-y-xs'>
            <h2 className="card-title bleu step-title">Etape 1 : Je joins mon attestation de droits à l'assurance maladie</h2>
            <p className='text mt-xs' style={{textAlign: 'justify'}}>Pour faciliter la saisie automatique de vos informations, vous devez télécharger votre attestation lisible et à jour.</p>
            
            <div className='form-row'>
              <div className='form-group mw-100'>
                {errorFileTypeMsg && <p className='text blanc p-sm bg-fushia'>{ERROR_MESSAGES.fileTypeMsg}</p> }
                {errorFileSizeMsg && <p className='text blanc p-sm bg-fushia'>{ERROR_MESSAGES.fileSizeMsg}</p> }
              </div>
            </div> 
            
            {displayPrincipalBeneficiary()}
            <div>
              {errorMsg && <MgpMessage type="danger" message={errorMsg} hasCloseBtn={true}/>}
            </div>


          </div>

          <div className='col-flex-4 bg-blanc shadow-noir p-md m-y-xs'>
            <h2 className="card-title bleu step-title">Etape 2 : Je vérifie ou complète mes informations</h2>
            <div className=''>
              {displaySocialSecurityInfo()}
            </div>

            <div className="mt-xl">
              <p className='text fw-medium'><span className='fushia'>(*)</span> Champs obligatoires</p>
            </div>
          </div>
        </div>

        {openPreviewFile&&file&&<UploadFilePreviewModal file={file} onUploadAction={onUploadAction} isOpen={openPreviewFile} onCloseModal={() => {setOpenPreviewFile(false); dispatch({type: 'SHOW_MODAL', showModal: false});}} showButton={showUploadButton}/>} 

        {imageUrl && <ImageModal isOpen={true} name={imageUrl} onCloseModal={handleCloseInfoModal} text={modalText}/>}
        
        {
          !showModal && <StickButtonsBloc disabledPreviousButton={proposition && isPropositionInLock(proposition) ? true : false} showNextButton={true} showPreviousButton={true} previousAction={onPreviousAction} nextAction={handleSubmit(onNextAction)}/>
        }

        {isShowModal && <QrCodeModal isOpen={isShowModal} onShowQrCode={showQrCodeModal} onCloseModal={closeModal} docCode={isPrincipalDoc ? "SOCIAL_SECURITY_CERTIFICATE" : "SOCIAL_SECURITY_CERTIFICATE_BENEFICIARY"} onEventMessage={onEventMessage} /> }
        {(isSubmitting || loading) && <LoaderModal hasMessage={false}/>}
        
      </form>
  )
}
